import type {
	MotornetVehicleImportValidationMatch,
	MotornetVehicleImportValidationRowResult,
} from '../types';
import type { ColorOptionalIndex } from '../common/motornetToForm';
import { isRowValid, type ImportedVehicleRow } from './parseImportExcel';

export type ImportStatusCode = 'valid' | 'invalid' | 'ambiguous';

export type ImportRowStatus = ImportStatusCode | 'checking';

const COLOR_NOT_FOUND_CODES = [
	'INTERNAL_COLOR_CODE_NOT_FOUND',
	'EXTERNAL_COLOR_CODE_NOT_FOUND',
] as const;

export function matchHasColorNotFound(
	match: MotornetVehicleImportValidationMatch
): boolean {
	return match.warnings.some((warning) =>
		COLOR_NOT_FOUND_CODES.includes(
			warning.code as typeof COLOR_NOT_FOUND_CODES[number]
		)
	);
}

export function deriveStatus(
	row: ImportedVehicleRow,
	result: MotornetVehicleImportValidationRowResult | undefined,
	isChecking: boolean
): ImportRowStatus {
	if (!isRowValid(row)) return 'invalid';

	if (!result) {
		return isChecking ? 'checking' : 'invalid';
	}

	const count = result.matches.length;
	if (count === 1) {
		return matchHasColorNotFound(result.matches[0]) ? 'invalid' : 'valid';
	}
	if (count > 1) return 'ambiguous';
	return 'invalid';
}

/**
 * Riga senza codice colore interno per un veicolo il cui listino ne ha:
 * si puo' sapere solo dopo aver caricato il listino.
 */
export function missingRequiredInteriorColor(
	row: ImportedVehicleRow,
	index: ColorOptionalIndex
): boolean {
	return index.interiorColorRequired && !row.codice_colore_interno?.trim();
}
